const STANDARD_WIDTH = 15
const SPLITED_WIDTH = 7.5
const STANDARD_HEIGHT = 100
export const isSplitted = (width) => {
    const remWidth = width % 15
    return !!(remWidth && remWidth <= SPLITED_WIDTH)
}
export const convertedWidth = (width) => {
   if (isSplitted(width)) return Math.floor(width / STANDARD_WIDTH) * STANDARD_WIDTH + SPLITED_WIDTH
   return Math.ceil(width / STANDARD_WIDTH) * STANDARD_WIDTH
}
export const getWidthDivision = (width) => {
    return Math.floor(width / STANDARD_WIDTH)
}
const countPieces = (arr) => {
    const result = [];
    const findIndex = (obj) => {
        return result.findIndex(item => item.width === obj.width && item.height === obj.height);
    };
    arr.forEach(piece => {
        const index = findIndex(piece);
        if (index !== -1) {
            result[index].count += 1;
        } else {
            result.push({ ...piece, count: 1 });
        }
    });
    return result;
};

export const generateTurfDescription = (totalTurf) => {
    const pieces = countPieces(totalTurf?.pieces)
    return `You need ${totalTurf?.totalPieces} ${totalTurf?.totalPieces > 1 ? 'pieces' : 'piece'} of turf ${pieces?.map((item) => (
        `${(totalTurf?.totalPieces !== item.count && pieces.length !== 1) ? item.count : totalTurf?.totalPieces === 1 ? `` : `each`} measuring ${item.width} x ${item.height}`
    )).join(', ')}`
}

export const totalPiecesCalculation = (width, height) => {
   // const HALF_WIDTH = STANDARD_WIDTH / 2;
    let totalPieces = 0;
    let pieces = [];
    // Handle full-width pieces (multiples of 15)
    let fullWidthPieces = Math.floor(width / STANDARD_WIDTH);
    let remainingWidth = width % STANDARD_WIDTH;
    // Handle full-height pieces
    let fullHeightPieces = Math.floor(height / STANDARD_HEIGHT);
    let remainingHeight = height % STANDARD_HEIGHT;
    // Add full-width and full-height pieces
    for (let i = 0; i < fullWidthPieces; i++) {
        if (fullHeightPieces > 0) {
            totalPieces += fullHeightPieces;
            for (let j = 0; j < fullHeightPieces; j++) {
                pieces.push({
                    width: STANDARD_WIDTH,
                    height: STANDARD_HEIGHT
                });
            }
        }
        if (remainingHeight >0) {
            totalPieces++;
            pieces.push({
                width: STANDARD_WIDTH,
                height: remainingHeight
            });
        }
    }
    // Special handling for leftover width
    if (remainingWidth > 0) {
        if (remainingWidth <= STANDARD_WIDTH/2) {
            // Cut from the middle and stack two half-pieces for half-width
            let remainingHeight = Math.floor(height  / 2) + 1
            if (remainingHeight < STANDARD_HEIGHT) {
                if (remainingHeight) {
                    totalPieces += 1;
                    pieces.push({
                        width: STANDARD_WIDTH,
                        height: remainingHeight
                    });
                }
            } else {
                totalPieces += 1;
                let remHeight = Math.floor(height  / 2) + 1
                let leftRemHeight = Math.floor(remHeight / STANDARD_HEIGHT);
                let remainderLeftHeight = remHeight%STANDARD_HEIGHT;

                if(leftRemHeight)
                {
                    for (let j = 0; j < leftRemHeight; j++) {
                        totalPieces++;
                        pieces.push({
                            width: STANDARD_WIDTH,
                            height: STANDARD_HEIGHT
                        });
                    }
                }
                pieces.push({
                    width: STANDARD_WIDTH,
                    height: remainderLeftHeight
                });
            }
        } else {
            if(remainingWidth > STANDARD_WIDTH/2){
                for (let j = 0; j < fullHeightPieces; j++) {
                    totalPieces++;
                    pieces.push({
                        width: STANDARD_WIDTH,
                        height: STANDARD_HEIGHT
                    });
                }
                if (remainingHeight){
                    totalPieces++;
                    pieces.push({
                        width: STANDARD_WIDTH,
                        height: remainingHeight
                    });
                }
            }
        }
    }
    return {
        totalPieces,
        pieces
    };
}